import { BrowserCacheLocation, Configuration, LogLevel, PopupRequest } from "@azure/msal-browser";



const ua = {
    msie: window.navigator.userAgent.indexOf("MSIE "),
    msie11: window.navigator.userAgent.indexOf("Trident/"),
    msedge: window.navigator.userAgent.indexOf("Edge/"),
    firefox: window.navigator.userAgent.indexOf("Firefox"),
  }
  
  export const msal_Utility = {
    userAgents: ua,
    isIE: ua.msie > 0 || ua.msie11 > 0,
    isEdge: ua.msedge > 0,
    isFirefox: ua.firefox > 0, // Only needed if you need to support the redirect flow in Firefox incognito
  
    loginRequest_Scopes: ['offline_access', 'openid'],
    
  }  

  type apirul = {
    name:string;
    url:string;
  }
  
  // export const AAD_ApiScopeAuthorized :apirul[] =[
  //   {
  //      name:"NFAPI400",
  //      url: "api://85efbf1a-7e16-41c7-8947-ced9c5fed1f4/.default", //NFAPI400
  //   },
  //   {
  //       name:"NEXTFRAME",
  //       url:"api://5d30dc67-db8d-4111-954a-697cf0d10eb7/.default", //NextFrame-API
  //   }    //"https://graph.microsoft.com/.default",
  // ];

    export const APIScopeAuthorized :apirul[] =[
        {
          name:"NEXTFRAME-EEID",
          url:"api://2396111d-c4e1-48d7-9936-038399e7bab7/.default",
         },
         {
         name:"NEXTFRAME-AAD",
         url:"api://5d30dc67-db8d-4111-954a-697cf0d10eb7/.default",
        },
        {
        name:"NFAPI400-EEID",
        url: "api://fec99765-d4c3-456b-8a0e-47fb9b9a78a9/.default",
        },
        {
        name:"NFAPI400-AAD",
        url: "api://85efbf1a-7e16-41c7-8947-ced9c5fed1f4/.default",
       },
    ];


  // Add here scopes for id token to be used at MS Identity Platform endpoints.
  export const loginRequestAAD: PopupRequest = {
      //Il Formato dello Scope deve essere quello dichiarato in Azure
      scopes: 
      [
         "openid",
         //"profile",
         "offline_access", 
         "https://graph.microsoft.com/.default",
        //"api://85efbf1a-7e16-41c7-8947-ced9c5fed1f4/.default", //NFAPI400
        //"api://5d30dc67-db8d-4111-954a-697cf0d10eb7/.default", //NextFrame-API
    ],
    };
    
    // Add here the endpoints for MS Graph API services you would like to use.
    export const graphConfig = {
        graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
    };












    export const msalConfig: Configuration = {
    auth: {
        //clientId: 'Enter_the_Application_Id_Here', // This is the ONLY mandatory field that you need to supply.
        clientId: process.env.REACT_APP_MSAL_CLIENT_ID || "",
        //authority: 'https://Enter_the_Tenant_Subdomain_Here.ciamlogin.com/', // Replace the placeholder with your tenant subdomain 
        authority: process.env.REACT_APP_MSAL_AUTHORITY || "",
        //knownAuthorities: [process.env.REACT_APP_MSAL_AUTHORITY || ""],
         
        redirectUri: '/', // Points to window.location.origin. You must register this URI on Microsoft Entra admin center/App Registration.
        postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
  
         
        //NextFrame AAD Clustering Navigator Login
        //clientId: "83fad748-a75e-46a9-a1fc-80eaf032ea5b",
        //authority:'https://login.microsoftonline.com/c1285312-2b75-4d2e-9779-38c582479035',

        
        //     // NextFrame AAD Development Login 
        //      //clientId: "5cbac7ab-7db5-4541-84c4-7618aa9706fa",
        //      //authority: 'https://login.microsoftonline.com/c1285312-2b75-4d2e-9779-38c582479035',
        
        //     //PROMOMEDIA BACKEND ITALYCASHPUGLIA
        //     //clientId: "2df0eb35-10e0-4d1c-aef3-baad59e84a11",
        //     // authority: 'https://login.microsoftonline.com/c1285312-2b75-4d2e-9779-38c582479035',
        
    },

        cache: {
            cacheLocation: BrowserCacheLocation.LocalStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
            storeAuthStateInCookie:false //msal_Utility.isIE || msal_Utility.isEdge || msal_Utility.isFirefox, // Set this to "true" if you are having issues on IE11 or Edge
        },
        system: {
            loggerOptions: {
                loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
                    if (containsPii) {
                        return;
                    }
                    switch (level) {
                        case LogLevel.Error:
                            console.error(message);
                            return;
                        case LogLevel.Info:
                            console.info(message);
                            return;
                        case LogLevel.Verbose:
                            console.debug(message);
                            return;
                        case LogLevel.Warning:
                            console.warn(message);
                            return;
                        default:
                            console.warn(message);
                            return;
                    }
                },
            },
        },
    };
    
 
    // auth: {
 
    //     //NextFrame AAD Dev Login 
    //     clientId:"5cbac7ab-7db5-4541-84c4-7618aa9706fa",
    //     authority:'https://login.microsoftonline.com/c1285312-2b75-4d2e-9779-38c582479035',

    //     redirectUri: '/', // Points to window.location.origin. You must register this URI on Microsoft Entra admin center/App Registration.
    //     postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
    //     navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
    //     //clientCapabilities: ["cp1"], // This is required for B2C, but not for AAD. Uncomment if you are using B2C.
    // },

    //     // auth: {
    //     //     // NextFrame AAD Development Login 
    //     //      //clientId: "5cbac7ab-7db5-4541-84c4-7618aa9706fa",
    //     //      //authority: 'https://login.microsoftonline.com/c1285312-2b75-4d2e-9779-38c582479035',
                        

    //     //     //CIAM dev-login
    //     //     clientId: "69a961a3-eed9-4734-b199-959c72dd4399",
    //     //     authority: "https://ssoNextFrameTatoParideSpa.ciamlogin.com/103be50a-7c7b-4613-b7f8-0302b420d280",
                     
                         
    //     //     //PROMOMEDIA BACKEND ITALYCASHPUGLIA
    //     //     //clientId: "2df0eb35-10e0-4d1c-aef3-baad59e84a11",
    //     //     // authority: 'https://login.microsoftonline.com/c1285312-2b75-4d2e-9779-38c582479035',
             
             
    //     //     redirectUri: "https://nfciamlogin.z38.web.core.windows.net",
    //     //     postLogoutRedirectUri: "/"
    //     // },
    //     cache: {
    //         cacheLocation: BrowserCacheLocation.LocalStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    //         storeAuthStateInCookie: msal_Utility.isIE || msal_Utility.isEdge || msal_Utility.isFirefox, // Set this to "true" if you are having issues on IE11 or Edge
    //     },
    //     system: {
    //         loggerOptions: {
    //             loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
    //                 if (containsPii) {
    //                     return;
    //                 }
    //                 switch (level) {
    //                     case LogLevel.Error:
    //                         console.error(message);
    //                         return;
    //                     case LogLevel.Info:
    //                         console.info(message);
    //                         return;
    //                     case LogLevel.Verbose:
    //                         console.debug(message);
    //                         return;
    //                     case LogLevel.Warning:
    //                         console.warn(message);
    //                         return;
    //                     default:
    //                         console.warn(message);
    //                         return;
    //                 }
    //             },
    //         },
    //     },
    // };

    // export const msalConfig_AAD_promomedia: Configuration = {
    // auth: {
 
    //     //     //PROMOMEDIA BACKEND ITALYCASHPUGLIA
    //     clientId: "2df0eb35-10e0-4d1c-aef3-baad59e84a11",

    //     redirectUri: '/', // Points to window.location.origin. You must register this URI on Microsoft Entra admin center/App Registration.
    //     postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
    //     navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
    //     //clientCapabilities: ["cp1"], // This is required for B2C, but not for AAD. Uncomment if you are using B2C.
    // },
    //     cache: {
    //         cacheLocation: BrowserCacheLocation.LocalStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    //         storeAuthStateInCookie: msal_Utility.isIE || msal_Utility.isEdge || msal_Utility.isFirefox, // Set this to "true" if you are having issues on IE11 or Edge
    //     },
    //     system: {
    //         loggerOptions: {
    //             loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
    //                 if (containsPii) {
    //                     return;
    //                 }
    //                 switch (level) {
    //                     case LogLevel.Error:
    //                         console.error(message);
    //                         return;
    //                     case LogLevel.Info:
    //                         console.info(message);
    //                         return;
    //                     case LogLevel.Verbose:
    //                         console.debug(message);
    //                         return;
    //                     case LogLevel.Warning:
    //                         console.warn(message);
    //                         return;
    //                     default:
    //                         console.warn(message);
    //                         return;
    //                 }
    //             },
    //         },
    //     },
    // };




    